import { useState, useRef, useEffect } from 'react';

export function useMinimumLoading(
  isLoading: boolean,
  minDuration = 200,
): boolean {
  const [showLoading, setShowLoading] = useState(isLoading);
  const loadStartRef = useRef<number>(0);

  useEffect(() => {
    if (isLoading) {
      loadStartRef.current = Date.now();
      setShowLoading(true);
    } else {
      const elapsed = Date.now() - loadStartRef.current;
      const remaining = Math.max(0, minDuration - elapsed);
      const timer = setTimeout(() => setShowLoading(false), remaining);
      return () => clearTimeout(timer);
    }
  }, [isLoading, minDuration]);

  return showLoading;
}
